<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.cityName"
              placeholder="请输入城市"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.storeName"
              placeholder="请输入店名"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.certificateNo"
              placeholder="请输入专卖证号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.phone"
              placeholder="请输入电话"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col style="width:60px;padding-left:10px;">
            <el-button
              type="primary"
              @click="searchData()"
            >
              搜索
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @dblclick="viewFun(arguments)"
        @view="viewFun(arguments)"
        @export="batchExport(masterList)"
        @addCollectionPlan="addCollectionPlanFun(arguments)"
      />
    </div>
    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :dialog-title="dialogViewTitle"
      :dialog-visible.sync="dialogViewVisible"
      :master-table-key="masterList.tableKey"
    />
    <!-- 采集品规设置 -->
    <collection-plan-dialog
      :data-id="id"
      :city-id="cityId"
      :dialog-title="'零售监测设置'"
      :dialog-visible.sync="dialogCollectionPlanVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 定义表头颜色，高度，搜索，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 查看
import ViewDialog from './components/viewDialog'
// 采集设置
import collectionPlanDialog from './components/collectionPlanDialog'
// 数据请求
import { loadStoreListDataApi, loadStoreExportDataApi } from '@/api/store'
export default {
  name: 'CollectStoreArchives',
  components: {
    CustomTable,
    TableOperation,
    ViewDialog,
    collectionPlanDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'collect_store_info_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['collect_store_info_collection_product'],
            prop: 'addCollectionPlan',
            label: '零售监测设置',
            method: 'addCollectionPlan'
          },
          {
            permissionSigns: ['collect_store_info_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['collect_store_info_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: 'id', // 排序字段
            order: 'desc' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            cityName: '',
            storeName: '',
            certificateNo: '',
            phone: '',
            billType: 1,
            isCollectionPoint: 1
          }
        }
      },
      id: null, // 选中的单据ID
      cityId: null,
      eventType: '',
      dialogAddEditTitle: '',
      dialogAddEditVisible: false,
      dialogViewTitle: '查看信息采集零售户档案信息',
      dialogViewVisible: false,
      dialogCollectionPlanVisible: false // 制定采集品规

    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '所属省区', filterColumn: 'province_name', width: 120 },
      { prop: 'cityName', label: '所属城市', filterColumn: 'city_name', width: 120 },
      { prop: 'countyName', label: '所属区县', filterColumn: 'county_name', width: 120 },
      { prop: 'storeSortStr', label: '零售户类型', filterColumn: 'store_sort', filterValue: 'storeSort', width: 150, filterArray: [{ label: '重点终端', value: 1 }, { label: '', value: 2 }, { label: '潜力终端', value: 3 }, { label: '信息采集终端', value: 4 }] },
      { prop: 'certificateNo', label: '专卖证号', filterColumn: 'certificate_no', width: 120 },
      { prop: 'storeName', label: '店名(专卖证)', filterColumn: 'store_name', width: 150 },
      { prop: 'address', label: '地址(专卖证)', width: 150 },
      { prop: 'realStoreName', label: '实际店名', filterColumn: 'real_store_name', width: 150 },
      { prop: 'realAddress', label: '实际地址', filterColumn: 'real_address', width: 150 },
      { prop: 'ownerName', label: '店主姓名', filterColumn: 'owner_name', width: 120 },
      { prop: 'phone', label: '联系电话', width: 120 },
      { prop: 'benxiangNo', label: '本香注册号码', filterColumn: 'benxiang_no', width: 140 },
      { prop: 'benxiangStoreNo', label: '本香门店编码', filterColumn: 'benxiang_store_no', width: 140 },
      { prop: 'levelStr', label: '档位', filterColumn: 'level_str', width: 100 },
      { prop: 'storeTypeStr', label: '店铺业态', filterColumn: 'store_type', filterValue: 'storeType', width: 120, filterArray: [{ label: '便利店', value: 1 }, { label: '小超市', value: 2 }, { label: '连锁超市', value: 3 }, { label: '烟酒店', value: 4 }, { label: '烟店', value: 5 }] },
      { prop: 'totalBackCabinetGroupNum', label: '背柜组数', filterColumn: 'total_back_cabinet_group_num', width: 120 },
      { prop: 'totalBackCabinetGridNum', label: '背柜格数', filterColumn: 'total_back_cabinet_grid_num', width: 120 },
      { prop: 'totalFloorCabinetGroupNum', label: '地柜组数', filterColumn: 'total_floor_cabinet_group_num', width: 120 },
      { prop: 'storeAreaStr', label: '店面面积', filterColumn: 'store_area', filterValue: 'storeArea', width: 120, filterArray: [{ label: '10平米以下', value: 1 }, { label: '10-20平米', value: 2 }, { label: '20平米以上', value: 3 }] },
      { prop: 'receiptDayStr', label: '到货时间', filterColumn: 'receipt_day', filterValue: 'receiptDay', width: 120, filterArray: [{ label: '周一', value: 1 }, { label: '周二', value: 2 }, { label: '周三', value: 3 }, { label: '周四', value: 4 }, { label: '周五', value: 5 }, { label: '周六', value: 6 }, { label: '周日', value: 7 }] },
      { prop: 'businessDistrictName', label: '所属商圈', filterColumn: 'business_district_name', width: 120 },
      { prop: 'collectionPlanStr', label: '单品采集时间', filterColumn: 'collection_plan', filterValue: 'collectionPlan', width: 150, filterArray: [{ label: '周一', value: 1 }, { label: '周二', value: 2 }, { label: '周三', value: 3 }, { label: '周四', value: 4 }, { label: '周五', value: 5 }, { label: '周六', value: 6 }, { label: '周日', value: 7 }] },
      { prop: 'collectionFrequencyStr', label: '单品采集频率', filterColumn: 'collection_frequency', filterValue: 'collectionFrequency', width: 150, filterArray: [{ label: '一周一次', value: 1 }] },
      { prop: 'collectionProductNames', label: '单品采集品规', filterColumn: 'collection_product_names', width: 150 },
      { prop: 'collectionUserName', label: '单品采集人', filterColumn: 'collection_user_name', width: 140 },
      { prop: 'monitorCollectionPlanStr', label: '零售监测采集时间', filterColumn: 'monitor_collection_plan', filterValue: 'monitorCollectionPlan', width: 160, filterArray: [{ label: '周一', value: 1 }, { label: '周二', value: 2 }, { label: '周三', value: 3 }, { label: '周四', value: 4 }, { label: '周五', value: 5 }, { label: '周六', value: 6 }, { label: '周日', value: 7 }] },
      { prop: 'monitorCollectionFrequencyStr', label: '零售监测采集频率', filterColumn: 'monitor_collection_frequency', filterValue: 'monitorCollectionFrequency', width: 150, filterArray: [{ label: '一周一次', value: 1 }] },
      { prop: 'monitorCollectionProductNames', label: '零售监测采集品规', filterColumn: 'monitor_collection_product_names', width: 160 },
      { prop: 'monitorCollectionUserName', label: '零售监测采集人', filterColumn: 'monitor_collection_user_name', width: 160 },
      { prop: 'terminalTypeNames', label: '应用分类', filterColumn: 'terminal_type_names', width: 160 },
      { prop: 'storeTagNames', label: '标签', filterColumn: 'store_tag_names', width: 320 },
      { prop: 'remark', label: '备注', width: 200 },
      { prop: 'operatorName', label: '操作人', filterColumn: 'operator_name', width: 150 },
      { prop: 'operationTimeStr', label: '操作时间', filterColumn: 'operation_time', width: 160, isBetween: true },
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadStoreListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 制定采集品规
    addCollectionPlanFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.cityId = args[0].cityId
      this.dialogCollectionPlanVisible = !this.dialogCollectionPlanVisible
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.dialogViewVisible = !this.dialogViewVisible
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadStoreExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
